import ContainerBox from "myshubhlife-component/container-box";
import * as React from "react";
import Button from "web-com/button";
import {imageBaseUrl} from "config";
import "./styles.scss";
import {handleConsentNavigation, RoutePaths} from "consent/route";
import {isWebview} from "utils";
import {AndroidApis} from "app";
import {partnerOfferings} from "login/config";
import {connect} from "react-redux";
import {IReduxState} from "reducers";

interface IConnectProps {
  utm_source: string;
}

const LoanReject = (props: IConnectProps) => {
  React.useEffect(() => {
    if (isWebview() && window.location.href.includes("android")) {
      AndroidApis.clearWebStack();
    }
  }, []);
  const handleSubmit = () => {
    handleConsentNavigation(RoutePaths.LOAN_DETAIL, false);
  }
  return (
    <ContainerBox>
      <div className="denied-offer">
        <div className="text-center bold flex-1">You have rejected your loan offer</div>
        <div className="text-center flex-1">
          <img
            src={`${imageBaseUrl}/img/icons/loan-rejecte-icon.svg`}
            width="100px"
            alt="Icon"
          />
        </div>
        <div className="text-center shrink flex-1">
          Loan offer still valid- your loan offer is awaiting you. Accept the
          loan offer below to continue or chat with us if you have any doubts
        </div>
        <div className="flex-1"><Button bgColor={partnerOfferings[props.utm_source]?.colors?.green} onClick={handleSubmit} width="100%" buttonText="Accept Loan"/></div>
      </div>
    </ContainerBox>
  );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
  return {
    utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
  };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(LoanReject);
